'use strict';
var classof = require('../internals/classof');

var $TypeError = TypeError;

// Perform ? RequireInternalSlot(argument, [[TypedArrayName]])
// If argument.[[TypedArrayName]] is not "Uint8Array", throw a TypeError exception
module.exports = function (argument) {
  if (classof(argument) === 'Uint8Array') return argument;
  throw new $TypeError('Argument is not an Uint8Array');
};



//////////////////
// WEBPACK FOOTER
// E:/Websites/eco-pest-group/app/public/wp-content/themes/pestaid-v2-4/node_modules/core-js/internals/an-uint8-array.js
// module id = 353
// module chunks = 0